RoundDetailService = ($http, $q, LocationTrackingService) ->
  roundPreviousLocations = {}
  savePreviousLocation: (id) ->
    #round-detail can only be access from dashboard/history
    previousLocation = LocationTrackingService.previousLocation()
    if roundPreviousLocations[id]
      #If we have previousLocation and new previousLocation from history/dashboard just update it
      #ex: dashboard -> round-detail/1 -> history -> round-detail/1
      roundPreviousLocations[id] = previousLocation if (previousLocation is '/history' or previousLocation is '/')
    else
      #If we dont have previousLocation -> assign previousLocation
      roundPreviousLocations[id] = previousLocation

  getPreviousLocation: (id) ->
    roundPreviousLocations[id]
  clearPreviousLocation: (id) ->
    roundPreviousLocations[id] = null
  getRound: (id) ->
    delay = $q.defer()
    $http.get("/api/score_cards/#{id}.json").then (resp) ->
      delay.resolve resp.data
    delay.promise
  getAnalysisDataRound: (id, params) ->
    delay = $q.defer()
    $http.get("/api/score_cards/#{id}/analysis.json", params: params).then (resp) ->
      delay.resolve resp.data
    delay.promise

RoundDetailService.$inject = [
  '$http'
  '$q'
  'LocationTrackingService'
]

module.exports = RoundDetailService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-detail-service.coffee